import {HiOutlineMail} from 'react-icons/hi'
import {FaWhatsapp} from 'react-icons/fa'
import { AiFillLinkedin } from 'react-icons/ai';


const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto: mfonudo44@gmail.com' },
    {id: 2, icon: <AiFillLinkedin/>, link: 'http://linkedin.com/in/mfonobong-udo-717b05127'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+2348068115654'}
  
]





export default data